import type { ContractResponse } from '@domain/schemas/contract.schema';
import type { EndorsementData } from '@domain/types/entity';

export const isEndorsementData = (entity?: Pick<ContractResponse, 'pk' | 'sk'>): entity is EndorsementData => {
  if (!entity) {
    return false;
  }

  return entity?.sk?.startsWith('endorsements#');
};
